import { z } from 'zod';
import { deliveryTypeSchema } from './getDeliveryTypes';
import { documentHeaderSchema } from './getSalesDocumentsWithConditions';
import { customerSchema } from '../traders/getCustomers';

export const getSalesDocumentByIdSchema = z.object({
  id: z.string(),
  createdDate: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  deleted: z.boolean(),
  deliveryType: deliveryTypeSchema.optional(),
  deliveryTypeId: z.string().optional(),
  customer: customerSchema.optional(),
  customerId: z.string().optional(),
  salesPerson: z.object({ id: z.string(), code: z.string(), name: z.string() }).optional(),
  salesPersonId: z.string().optional(),
  documentHeader: documentHeaderSchema,
});

export type GetSalesDocumentByIdResponse = z.infer<typeof getSalesDocumentByIdSchema>;
